//
//
//


import { enable_webp } from '@/common/utils/map_view_data'
import WX_API from '@/utils/wx_api'
import { getSystemInfo } from '@/utils/wx_api'

const V_MAX_WIDTH = 375
const V_MAX_HEIGHT = 812

const H_MAX_WIDTH = 480

export default {
    props: {
        src: String
    },
    data () {
        return {
            style: {}
        }
    },
    async mounted () {
        this.style = {
            width: '15rem'
        }
    }
}
